import { render } from "./MedicalRecordTitle.vue?vue&type=template&id=8cf4bf86&scoped=true"
import script from "./MedicalRecordTitle.vue?vue&type=script&lang=js"
export * from "./MedicalRecordTitle.vue?vue&type=script&lang=js"

import "./MedicalRecordTitle.vue?vue&type=style&index=0&id=8cf4bf86&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf4bf86"]])

export default __exports__